import React from 'react';
import formatAsCurrency from '../../CommonUtils/formatAsCurrency';
import { HtmlTable } from '../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../CommonComponents/OPL/Icon/Icon';
import { TableRow } from '../Dashboard.styles';
import { TopDashboardData } from '../api/useDashboardQuery';
import { PDFSafeTableHeaderCaption } from '../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';

interface Props {
  title: string;
  headers: string[];
  data: TopDashboardData[];
}

export const DashboardTable = ({ title, headers, data }: Props) => {
  return (
    <HtmlTable minHeight={200} width="48%" mb="24">
      <table style={{ tableLayout: 'fixed' }}>
        <colgroup>
          <col width="60%" />
          <col width="40%" />
        </colgroup>
        <thead>
          <PDFSafeTableHeaderCaption colSpan={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              {title}
              <Icon className="fas fa-sort-amount-down" height={24} />
            </Box>
          </PDFSafeTableHeaderCaption>
          <tr>
            <th>
              <Text variant="smallCaps" textAlign="left">
                {headers[0]}
              </Text>
            </th>
            <th>
              <Text variant="smallCaps" textAlign="right">
                {headers[1]}
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map(client => (
            <TableRow
              key={client.id}
              onClick={() => ADV.util.Router.go2('ConsumerOverview', { clientId: client.id })}
            >
              <td>
                <Text textAlign="left" isTruncated>
                  {client.name}
                </Text>
              </td>
              <td>
                <Text variant="tabular" textAlign="right" isTruncated>
                  {formatAsCurrency(client.total)}
                </Text>
              </td>
            </TableRow>
          ))}
        </tbody>
      </table>
    </HtmlTable>
  );
};
